import React from 'react';

const emptyPieColor = '#FFFFFF';
const filledPieColor = '#E9FAE3';

const PieChart = ({ percent }) => {
  const percentToDegrees = () => {
    let angle = 360 * ((percent - 50) / 100);

    if (percent > 50) {
      angle -= 90;
    } else {
      angle += 90;
    }

    return angle;
  };

  const movableHalfColor = percent > 50 ? filledPieColor : emptyPieColor;
  const degreesToMove = percentToDegrees();

  return (
    <div className="w-36 h-36 rounded-full border border-[#474747] overflow-hidden p-[1px] bg-white">
      <div
        className="w-full h-full rounded-full relative"
        style={{
          backgroundImage: `linear-gradient(-90deg, ${filledPieColor} 50%, transparent 50%), linear-gradient(90deg, ${emptyPieColor} 50%, transparent 50%)`,
        }}
      >
        <div
          className="w-full h-full rounded-full absolute"
          style={{
            backgroundImage: `linear-gradient(${degreesToMove}deg, ${movableHalfColor} 50%, transparent 50%)`,
          }}
        >
          <div
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
              bg-white py-1 px-2 text-primary text-sm font-primaryMedium
              rounded-3xl shadow-md"
          >
            {percent}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieChart;
